import React from "react";

const TimePicker = ({
  name,
  label,
  value,
  error,
  required = false,
  onChange,
  className = "",
  ...props
}) => {
  const handleChange = (e) => {
    onChange(name, e.target.value);
  };

  return (
    <div className={`form-field form-group ${className}`}>
      <label className="form-field__label form-label" htmlFor={name}>
        {label}
        {required && (
          <span className="form-field__required text-danger ms-1">*</span>
        )}
      </label>

      <input
        name={name}
        id={name}
        type="time"
        value={value}
        className={`form-field__input form-control ${
          error ? "form-field__input--error is-invalid" : ""
        }`}
        onChange={handleChange}
        required={required}
        {...props}
      />

      {error && (
        <div className="form-field__error invalid-feedback d-block">
          {error}
        </div>
      )}
    </div>
  );
};

export default TimePicker;
